import _isNil from "ramda/es/isNil";
import _propSatisfies from "ramda/es/propSatisfies";
export default _propSatisfies(_isNil);